import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["data-testid"]
const _hoisted_2 = { class: "flex items-start gap-4" }
const _hoisted_3 = { class: "flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-white border border-gray-100" }
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "flex flex-wrap items-center gap-2" }
const _hoisted_6 = { class: "text-base font-bold text-gray-900" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "rounded-full bg-primary5 border border-primary px-2 py-0.5 text-xs font-medium text-primary" }, " Em breve ", -1)
const _hoisted_8 = { class: "text-sm text-gray-500 mt-1" }


export default /*#__PURE__*/_defineComponent({
  __name: 'ComingSoonCard',
  props: {
    icon: {},
    title: {},
    description: {},
    testId: { default: 'coming-soon-card' }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!

  return (_openBlock(), _createElementBlock("div", {
    class: "rounded-2xl border border-dashed border-gray-200 bg-gray-50/60 p-6 text-left opacity-90",
    "data-testid": _ctx.testId
  }, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "22",
          color: "grey-darken-1"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.icon), 1)
          ]),
          _: 1
        })
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.title), 1),
          _hoisted_7
        ]),
        _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.description), 1)
      ])
    ])
  ], 8, _hoisted_1))
}
}

})